import Vue from "vue";
import { apiConstants } from "../../config";
import { apiPost } from "../../../../shared/services";
import { apiPut } from "../../../../shared/services/api-requests/api-put";

const fetchRoles = options => {
  const url = apiConstants.roles;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchPermissions = options => {
  const url = apiConstants.permissions;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const saveRole = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.roles + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.roles;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchRole = async id => {
  const url = apiConstants.roles;
  return Vue.axios.get(url + "/" + id).then(res => res.data);
};

const deleteRole = async id => {
  const url = apiConstants.roles;
  return await Vue.axios.delete(url + "/" + id);
};

export { fetchRoles, saveRole, deleteRole, fetchRole, fetchPermissions };
